const data = [
  {
    name: "Covid Education Campaign",
    link: "https://scientiamag.org/all-we-need-is-empathy-during-the-pandemic-days/",
    text: "Creating educational resources in English, Urdu, Sindhi, Pushto and Balochi on prevention against covid.",
    image: "/img/projects/covid.jpg",
  },
  {
    name: "Learners Charter",
    link: "https://www.facebook.com/GenesMachines.io/posts/3476818019003903",
    text: "Collaborating on a charter of recommendations with STEM organizations to finance, support and promote girls education at public schools.",
    image: "/img/projects/learners.jpg",
  },
  {
    name: "Science Policy Roundtable",
    link: "https://learnersrepublic.com/covid-19-science-and-public-policy/",
    text: "Developing a national health science policy recommendations with scientists, doctors, public health experts, economists, civil services officers and public policy experts.",
    image: "/img/projects/policy.jpg",
  },

  {
    name: "Science Policy Bootcamp",
    link: "https://www.facebook.com/GenesMachines.io/posts/3856040647748303?__tn__=%2CO*F",
    text: "Training highschool, undergraduate and post-graduate students in science policy with experts from Ministry of Foreign Affairs Pakistan, Imperial College London, Nature-Science & Technology Australia and Institut NeuroMyogene France.",
    image: "/img/projects/bootcamp.jpg",
  },

  {
    name: "Life Sciences Career Counselling",
    link: "#contact",
    text: "Providing Life Sciences career counselling to students and unemployed youth within the Life Sciences sector.",
    image: "./img/projects/career.jpg",
  },
  {
    name: "Science Chowk",
    link: "/gallery",
    text: "A live video podcast series featuring Pakistanis working on the topics of science, technology and society.",
    image: "./img/projects/chowk.jpg",
  },
];

export default data;
